import { InjectionToken } from '@angular/core';
import { NavSection } from './nav-section.model';

// Multi-provider token. Each feature registers its own NavSection.
// Usage in app.config.ts:
//   { provide: NAV_SECTIONS, useValue: { title: 'Mi sección', items: [...] }, multi: true }
export const NAV_SECTIONS = new InjectionToken<NavSection>('NAV_SECTIONS');
